import { SportNavMobileHeader } from './sportNavMobileHeader';
import classNames from 'classnames';
import { selectIsNavMobileOpened } from 'features/sport/selectors';
import styles from './SportNavMobile.module.scss';
import { useBlockScroll } from 'hooks/useBlockScroll';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useTypedSelector } from 'lib/centralStore';
import { SportNavMobileProps } from '.';

export const SportNavMobile = ({ children, className }: SportNavMobileProps) => {
  const isNavMobileOpened = useTypedSelector(selectIsNavMobileOpened);
  const sportHeaderStickyLabel = useGetLabelByKey('sport-header-sticky');

  useBlockScroll(isNavMobileOpened);

  return (
    <div
      className={classNames(styles.container, { [styles.visibile]: isNavMobileOpened }, className ?? '')}
      suppressHydrationWarning
    >
      <SportNavMobileHeader label={sportHeaderStickyLabel} />
      {isNavMobileOpened && children}
    </div>
  );
};
